import { Avatar, Grid, Stack, Typography } from '@mui/material';
import useColorsStyles from 'common/colors';
import ActionButton from 'common/components/ActionButton';
import CustomTooltip from 'common/components/CustomTooltip';
import useFlexBoxStyles from 'common/flexBox';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getEventsSavePending } from 'redux/slices/eventSlice';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    paddingBottom25pct: {
        paddingBottom: '25%',
    },
    marginTop8: {
        marginTop: theme.spacing(8),
    },
    borderRight: {
        borderRight: '1.5px solid',
    },
    avatarBig: {
        width: theme.spacing(8),
        height: theme.spacing(8),
    },
}));

const EventFormConfirm = (props) => {
    const { type, event, actors, cancel, onSubmit } = props;
    const { t } = useTranslation();
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const { classes } = useStyles();
    const { classes: colors } = useColorsStyles();

    const savePending = useSelector(getEventsSavePending);

    function validateForm() {
        return true; // TODO
    }

    const getDate = () => {
        if (event.instant) {
            return moment(new Date()).format('MMM.DD').toUpperCase();
        }
        return moment(event.releaseDate).format('MMM.DD').toUpperCase();
    };

    const getTime = () => {
        if (event.instant) {
            return moment(new Date()).format('hh:mm A').toUpperCase();
        }
        return moment(event.releaseDate).format('hh:mm A').toUpperCase();
    };

    return (
        <Stack direction="column" className={cx(flexBox.overflowHidden, flexBox.h100)}>
            <Stack direction="column" className={cx(flexBox.overflowXHidden, flexBox.scrollbarNone, flexBox.h100)}>
                <Stack
                    direction="column"
                    justifyContent="center"
                    className={cx(flexBox.grow1, flexBox.h100, classes.paddingBottom25pct)}
                >
                    <Typography variant="onliveH5" fontWeight={'bold'}>
                        {event?.name?.toUpperCase()}
                    </Typography>
                    <Typography variant="subtitle1" fontWeight={500} className={flexBox.marginTop2}>
                        {event.description}
                    </Typography>

                    <Grid container spacing={1}>
                        {(type !== 'one_to_one' || event.releaseDate) && (
                            <Grid item md={6} sm={12} className={classes.marginTop8}>
                                <Typography
                                    variant="subtitle1"
                                    fontWeight={500}
                                    className={cx(flexBox.marginTop2, flexBox.opacity05)}
                                >
                                    {t('event.eventFormConfirm.releaseDate')}
                                </Typography>
                                <Stack direction="row">
                                    <Typography
                                        variant="onliveH5"
                                        className={cx(classes.borderRight, flexBox.paddingRight1, flexBox.marginRight1)}
                                        fontWeight={400}
                                        noWrap
                                    >{`${getDate()}`}</Typography>
                                    <Typography variant="onliveH5" fontWeight={400} noWrap>{`${getTime()}`}</Typography>
                                </Stack>
                            </Grid>
                        )}
                        <Grid item md={6} ms={12} className={classes.marginTop8}>
                            <Typography
                                variant="subtitle1"
                                fontWeight={500}
                                className={cx(flexBox.marginTop2, flexBox.opacity05)}
                            >
                                {t('event.eventFormConfirm.actors')}
                            </Typography>
                            <Stack direction="row" className={cx(flexBox.marginTop1, flexBox.wrap)}>
                                {actors.map((actor, idx) => {
                                    return (
                                        <Stack
                                            direction="column"
                                            alignItems="center"
                                            key={idx}
                                            className={cx(
                                                flexBox.cursorPointer,
                                                idx !== actors.length && flexBox.marginRight1,
                                            )}
                                        >
                                            <CustomTooltip arrow key={actor.email} title={actor.email}>
                                                <Avatar
                                                    className={cx(colors.textWhite, classes.avatarBig)}
                                                    key={actor.email}
                                                    src={actor.avatar || '/broken-image.jpg'}
                                                />
                                            </CustomTooltip>

                                            {actor.role === 'host' && actor.isAdmin ? (
                                                <Typography fontWeight={500} className={flexBox.paddingTop05}>
                                                    {t('event.eventFormConfirm.admin')}
                                                </Typography>
                                            ) : (
                                                <Typography fontWeight={500} className={flexBox.paddingTop05}>
                                                    {actor.role.charAt(0).toUpperCase() +
                                                        actor.role.substr(1).toLowerCase().replace('_', ' ')}
                                                </Typography>
                                            )}
                                        </Stack>
                                    );
                                })}
                            </Stack>
                        </Grid>
                    </Grid>
                </Stack>
            </Stack>

            <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                spacing={1}
                className={flexBox.paddingTop2}
            >
                <ActionButton disabled={savePending} onClick={cancel} color="default" fitWidth>
                    {t('multimedia.multimediaForm.cancel')}
                </ActionButton>

                <ActionButton
                    color="primary"
                    autoFocus
                    fitWidth
                    disabled={!validateForm() || savePending}
                    spinner={savePending}
                    onClick={onSubmit}
                >
                    {t('event.eventFormConfirm.save')}
                </ActionButton>
            </Stack>
        </Stack>
    );
};

export default EventFormConfirm;
